import { apiClient } from './client';

export const modulesAPI = {
  // Get all modules
  getAllModules: () => 
    apiClient.get('/api/v1/ac/modules/'),
  
  // Get module by ID
  getModuleById: (moduleId) => 
    apiClient.get(`/api/v1/ac/modules/${moduleId}`),
  
  // Get module permissions
  getModulePermissions: (moduleId) => 
    apiClient.get(`/api/v1/ac/modules/${moduleId}/permissions`),
  
  // Get permission by ID
  getPermissionById: (moduleId, permissionId) => 
    apiClient.get(`/api/v1/ac/modules/${moduleId}/permissions/${permissionId}`),
};